import { Dispatch, FC, HTMLAttributes, SetStateAction, useMemo } from 'react';
import { useField } from 'formik';
import { IBaseField } from './BaseField';
import { FieldControl } from 'src/UI';
import RadioField, { OptionsType, ValuesType }  from 'src/Controls/RadioField';

interface IRadioFieldProps extends HTMLAttributes<HTMLDivElement>, IBaseField {
	setData: Dispatch<SetStateAction<string[]>>;
	options: any[];
	col?: boolean;
	multiple?: boolean;
};

/** Обертка над Радиокнопками для использования его формой */
const RadiosField: FC<IRadioFieldProps> = ( props ) => {

	const { name, title, options, setData, onChangeValue, disabled = false, isRequired, col, multiple,
		className, ...otherProps 
	} = props;
	const [ inputProps, meta, helpers ] = useField( name );

	const onChangeValueHandler = ( value: ValuesType ) => {
		helpers.setTouched( true );
		helpers.setValue( value, true );
		if ( !!onChangeValue ) {
			onChangeValue( value );
		}
		!!setData && setData((data: any) => {
			return { ...data, [name]: value }
		});
	};

	const opt = useMemo( (): OptionsType => {
		return options.map( o => ({ value: o.value, label: o.display }))
	}, [ options ] );
;
	return (
		<FieldControl
			name={name}
			notFixedHeight
			isRequired={isRequired}
			title={title ?? ""}
			errorMsg={meta.error}
			isInvalid={!!meta.error}
			tabIndex={0}
			{...otherProps}
		>
			<RadioField
				{...inputProps}
				dir={col ? "col" : "row"}
				multiple={multiple}
				options={opt}
				onChangeValue={onChangeValueHandler}
			/>
		</FieldControl>
	);
};

export default RadiosField;
